export default {
  snackbar: {},
  formData: {},
  tyPixels: {},
  userProfile: {},
  couponData: {},
  otpRequestId: null
};
